























































































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import Tooltip from '@/components/UI/Tooltip.vue';
import IFilter from '@/components/lfs/NewShardList/icons/IFilter.vue'
import IExport from '@/components/icons/IExport.vue'
import ITimer from '@/components/lfs/NewShardList/icons/ITimer.vue'
import IUpload from '@/components/lfs/NewShardList/icons/IUpload.vue'
import Search from "@/components/UI/Search.vue";
import BtnDefault from '@/components/UI/BtnDefault.vue';

const newshards = namespace('newshards')
const profileStore = namespace('profile')
const dialog = namespace('dialog')
const forms = namespace('forms')
const survey = namespace('survey')

@Component({
  components: {
    Tooltip,
    Search,
    BtnDefault,
    'i-filter': IFilter,
    'i-export': IExport,
    'i-timer': ITimer,
    'i-upload': IUpload,
  }
})

export default class Toolbar extends Vue {
  @dialog.Mutation('SetFullDialogShow') protected SetFullDialogShow: any
  @dialog.Mutation('SetTitleDialog') protected SetTitleDialog: any
  @dialog.Mutation('SetFormSDialog') protected SetFormSDialog: any

  @dialog.Getter('fullDialogShow') protected fullDialogShow: any
  @forms.Mutation('setOptions') protected setOptions: any
  @newshards.Mutation('clearFilterShards') protected clearFilterShards: any
  @newshards.Mutation('clearSearch') protected clearSearchFun: any
  @newshards.Mutation('setPageOne') protected setPageOne: any

  @profileStore.Getter('profilesMap') protected profiles: any

  @survey.Getter('SurveysFromServer') protected SurveysFromServer: any

  @newshards.Getter('disableSearch') protected disableSearch: any
  @newshards.Getter('GetFilterShards') protected FilterShards: any
  @newshards.Getter('getCurrentFilterShards') protected getCurrentFilterShards: any
  @newshards.Getter('GetCountFiltersShards') protected GetCountFiltersShards: any
  @newshards.Mutation('setCurrentFilterShards') protected setCurrentFilterShards: any

  @Prop({type: [Boolean], default: false}) protected isSelectedShard!: boolean
  @Prop({type: [Boolean], default: false}) protected isArchive!: boolean
  @Prop({type: [Object], default: {}}) protected shard!: any
  @Prop({type: [Boolean], default: false}) protected menuDatePicker!: boolean
  @Prop({type: [Boolean], default: false}) protected isEmpty!: boolean
  timeout: any = 0

  // search: string = this.FilterShards[8].value

  changeDatePicker(menu:boolean) {
    this.$emit("changeMenuDatePicker", menu);
  }

  diff(a1: [], a2: []) {
    return JSON.stringify(a1) == JSON.stringify(a2) ? true : false
  }

  get searchFun() {
    return this.FilterShards.length > 8 ? this.FilterShards[8].value : false
  }

  exportAll() {
    this.setOptions()
    this.SetTitleDialog(this.$t('newShardList.export.titleFirst'))
    this.SetFormSDialog('ExportAllForm')
    this.SetFullDialogShow(true)
  }

  @Watch('searchFun', {immediate: true, deep: true})
  onChangedSearch(newVal:any, oldVal:any) {

    if(newVal!== undefined){
      console.log('onChangedSearch')
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.setPageOne()
        this.filter()
      }, 500);
    }
  }

  @Watch('menu', {immediate: true, deep: true})
  reloadMenu(oldval: any,newVal:any) {
    if (newVal  == true) {
      this.filter()
    }
  }

  clearSearch() {
    this.clearSearchFun()
    this.$emit('updateFilter', true)
  }

  filter() {
    this.menu = false
    if (!this.diff(this.FilterShards, this.getCurrentFilterShards)) this.$emit('updateFilter', true)
  }

  clickFilter() {
    this.setCurrentFilterShards()
  }

  clearFilterShardsFun() {
    this.clearFilterShards()
    this.filter()
  }

  filter1: string = 'all'
  get tags(){
    return [
      {id: 'all', text: this.$t('newShardList.filter.hotLevel.all')},
      {id: '1', text: this.$t('newShardList.filter.tags.new'), value: 'isNew'},
      {id: '2', text: this.$t('newShardList.filter.tags.isExistent'), value: 'exists'},
      {id: '3', text: this.$t('newShardList.filter.tags.isNull'), value: 'none'},
    ]
  }

  get actual(){
    return [
      {id: 'all', text: this.$t('newShardList.filter.hotLevel.all')},
      {id: '1', text: this.$t('newShardList.filter.actual.notArchive'), value: true},
      {id: '2', text: this.$t('newShardList.filter.actual.archive'), value: false}
    ]
  }

  get hotLevels(){
    return [
      {id: 'all', text: this.$t('newShardList.filter.hotLevel.all')},
      {id: '1', text: this.$t('newShardList.filter.hotLevel.one'), value: 'cold',},
      {id: '2', text: this.$t('newShardList.filter.hotLevel.two'), value: 'warm'},
      {id: '3', text: this.$t('newShardList.filter.hotLevel.three'), value: 'hot'},
      {id: '4', text: this.$t('newShardList.filter.hotLevel.four'), value: 'none'},
    ]
  }
  get surveys(){
    return  [
      {id: 'all', text: this.$t('newShardList.filter.hotLevel.all')},
      {id: '1', text: this.$t('newShardList.filter.survey.forYour')},
      {id: '2', text: this.$t('newShardList.filter.survey.forVisitor')},
      {id: '3', text: this.$t('newShardList.filter.survey.forVip')},
    ]
  }
  get notes(){
    return [
      {id: 'all', text: this.$t('newShardList.filter.hotLevel.all')},
      {id: '1', text: this.$t('newShardList.filter.notes.isNotes')},
      {id: '2', text: this.$t('newShardList.filter.notes.notNotes')},

    ]
  }
  get typeContacts(){
    return [
      {id: 'all', text: this.$t('newShardList.filter.hotLevel.all')},
      {id: '1', text: this.$t('newShardList.filter.typeContact.company'), value: 'company'},
      {id: '2', text: this.$t('newShardList.filter.typeContact.product'), value: 'product'},
      {id: '3', text: this.$t('newShardList.filter.typeContact.person'), value: 'person'},
    ]
  }
  menu: boolean = false



}
